import { ChangeDetectionStrategy, Component, computed, effect, inject, input } from '@angular/core';
import { CartItemComponentStore, USE_CART } from 'cart-data';
import { ItemComponentBase } from 'products-ui';
import { StandardCartItemSummaryViewComponent } from './views/standard-cart-item-summary-view/standard-cart-item-summary-view.component';

@Component({
  selector: 'ideal-standard-cart-item-summary',
  imports: [StandardCartItemSummaryViewComponent],
  standalone: true,
  templateUrl: './standard-cart-item-summary.component.html',
  styleUrl: './standard-cart-item-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CartItemComponentStore],
})
export class StandardCartItemSummaryComponent extends ItemComponentBase {
  private readonly _store = inject(CartItemComponentStore);

  protected readonly isLoading = computed(() => this._store.cartItemLoading() || this._store.cartItemLoading());
  protected readonly isPriceOnRequest = computed(() => this._store.cartItemPricing().pricingModel.isCallForPricing);
  protected readonly isUpdating = computed(() => this._store.cartItemUpdating());
  protected readonly cartItem = computed(() => this._store.cartItemPricing());
  protected readonly cartItemQuantity = computed(() => this._store.cartItemQuantity());

  constructor() {
    super();
    effect(() => {
      this._store.selectByItemId(this.itemId());
    });
  }

  protected onQuantityChange(quantity: number) {
    this._store.updateItemQuantity(quantity);
  }
}
